import styled from 'styled-components';
import { media } from '~src/styles/media-templates';

export const InputLabelContent = styled.div`
  margin-top: 0.3rem;
  font-size: 12px;
`;

export const InputLabelHeader = styled.span`
  font-size: 0.98rem;
  font-weight: 400;
  line-height: 1.73;
`;

export const UnderlinedButtonStyled = styled.span<{$disabled?: boolean}>`
  flex-grow: 1;
  font-size: 15px;
  line-height: 1.73;
  text-align: right;
  color: ${({ theme }) => theme.baseBlue.a10};
  text-decoration: underline;
  cursor: pointer;
  ${({ $disabled, theme }) => 
    $disabled &&
    `
    color: ${theme.baseBlue.a6};
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  `}

  &:hover {
    color: ${({ theme }) => theme.baseBlue.a6};
  }
  ${media.tablet`
  `}
`;
